
import { workTasklableIndexAPI, workTasklableUpdateOrderAPI } from '@/api/pm/tag';

import ProjectCell from '../components/ProjectCell';
import SectionHead from '../components/SectionHead';
import Draggable from 'vuedraggable';

import { on, off } from '@/utils/dom';

export default {
  // 任务看板
  name: 'TagBoard',
  components: {
    ProjectCell: ProjectCell,
    SectionHead: SectionHead,
    Draggable: Draggable
  },
  props: {
    visible: Boolean
  },
  data: function data() {
    return {
      searchInput: '',
      list: []
    };
  },

  computed: {
    showList: function showList() {
      var _this = this;

      return this.list.filter(function (item) {
        return item.name.indexOf(_this.searchInput) != -1;
      });
    }
  },
  watch: {
    visible: function visible(value) {
      if (value) {
        this.getList();
      }
    }
  },
  created: function created() {
    this.getList();
  },
  mounted: function mounted() {
    on(document, 'click', this.handleDocumentClick);
  },
  beforeDestroy: function beforeDestroy() {
    off(document, 'click', this.handleDocumentClick);
  },

  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;

      workTasklableIndexAPI().then(function (res) {
        _this2.list = res.data.list;
      }).catch(function () {});
    },


    /**
     * 进入详情
     */
    enterDetail: function enterDetail(item) {
      this.$router.push({
        name: 'tag-list',
        params: {
          id: item.lable_id
        }
      });

      this.handleClose();
    },


    /**
     * 拖拽
     */
    moveItem: function moveItem(evt) {
      if (evt) {
        // 如果没有进行移动 不做处理
        if (evt.oldIndex == evt.newIndex) {
          return;
        }
        workTasklableUpdateOrderAPI({
          labelIds: this.list.map(function (item) {
            return item.labelId;
          })
        }).then(function (res) {}).catch(function () {});
      }
    },


    /**
     * 关闭
     */
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },


    /**
     * 控制导航管理隐藏
     */
    handleDocumentClick: function handleDocumentClick(e) {
      var contentDom = document.querySelector('.el-drawer__body');
      if (!contentDom || contentDom.contains(e.target) || e.target.className && e.target.className.indexOf('wk-label') != -1 || e.target.innerHTML && e.target.innerHTML.indexOf('wk-label') != -1) return;
      this.handleClose();
    }
  }
};